/* ─── Praveda Design System ── uses CSS custom properties so both
       light and dark themes work without touching page components ─── */

export const inputStyle = {
  width: '100%', padding: '9px 12px', borderRadius: 8,
  border: '1px solid var(--input-border)', fontSize: 13,
  outline: 'none', color: 'var(--text-primary)',
  background: 'var(--bg-input)',
  boxSizing: 'border-box',
};

export const filterInputStyle = {
  padding: '8px 12px', borderRadius: 8,
  border: '1px solid var(--border)', fontSize: 13,
  color: 'var(--text-primary)',
  background: 'var(--bg-input)',
  outline: 'none',
};

export const labelStyle = {
  fontSize: 11, fontWeight: 600, color: 'var(--text-muted)',
  display: 'block', marginBottom: 6,
  textTransform: 'uppercase', letterSpacing: 0.5,
};

export const cardStyle = {
  background: 'var(--bg-card)',
  border: '1px solid var(--border)',
  borderRadius: 12,
};

export const modalWrap = {
  background: 'var(--bg-modal)',
  borderRadius: 16, padding: '32px',
  boxShadow: '0 32px 80px rgba(0,0,0,0.35), 0 0 0 1px rgba(99,102,241,0.15)',
  maxHeight: '90vh', overflowY: 'auto',
};

export const primaryBtn = (loading = false) => ({
  background: loading ? 'var(--bg-card)' : 'linear-gradient(135deg, #6366f1, #8b5cf6)',
  color: loading ? 'var(--text-muted)' : '#fff',
  border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600,
  cursor: loading ? 'not-allowed' : 'pointer',
  padding: '10px',
});

export const cancelBtn = {
  background: 'var(--bg-card)',
  border: '1px solid var(--border)',
  color: 'var(--text-sub)', borderRadius: 8,
  padding: '10px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
};

export const thStyle = {
  padding: '10px 16px', textAlign: 'left',
  fontSize: 10, fontWeight: 700, color: 'var(--text-muted)',
  textTransform: 'uppercase', letterSpacing: 0.5,
  whiteSpace: 'nowrap',
};

export const successAlert = {
  background: 'rgba(34,197,94,0.12)', color: '#4ade80',
  border: '1px solid rgba(34,197,94,0.25)',
  padding: '12px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600,
  marginBottom: 16,
};

export const errorAlert = {
  background: 'rgba(239,68,68,0.12)', color: '#f87171',
  border: '1px solid rgba(239,68,68,0.2)',
  padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16,
};

export const infoBox = {
  background: 'rgba(99,102,241,0.1)', border: '1px solid rgba(99,102,241,0.25)',
  borderRadius: 8, padding: '10px 14px', marginBottom: 20,
};

export const filterBar = {
  background: 'var(--bg-card)',
  border: '1px solid var(--border)',
  borderRadius: 12, padding: '14px 16px', marginBottom: 16,
  display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center',
};

export function pillBtn(active) {
  return {
    padding: '5px 14px', borderRadius: 20, fontSize: 12,
    fontWeight: 600, cursor: 'pointer', border: 'none',
    background: active ? 'linear-gradient(135deg,#6366f1,#8b5cf6)' : 'var(--bg-card)',
    color: active ? '#fff' : 'var(--text-muted)',
    boxShadow: active ? '0 2px 8px rgba(99,102,241,0.4)' : 'none',
    border: active ? 'none' : '1px solid var(--border)',
  };
}

/* Convenience — keeps the C.* usage consistent with before */
export const C = {
  bgCard:       'var(--bg-card)',
  bgCardHover:  'var(--bg-card-hover)',
  bgInput:      'var(--bg-input)',
  border:       'var(--border)',
  borderAccent: 'var(--border-accent)',
  text:         'var(--text-primary)',
  textSub:      'var(--text-sub)',
  textMuted:    'var(--text-muted)',
  accentLight:  '#a5b4fc',
  success: { bg: 'rgba(34,197,94,0.15)',   text: '#4ade80' },
  warn:    { bg: 'rgba(234,179,8,0.15)',    text: '#fbbf24' },
  error:   { bg: 'rgba(239,68,68,0.15)',    text: '#f87171' },
  info:    { bg: 'rgba(14,165,233,0.15)',   text: '#38bdf8' },
  purple:  { bg: 'rgba(139,92,246,0.15)',   text: '#c084fc' },
  pink:    { bg: 'rgba(236,72,153,0.15)',   text: '#f9a8d4' },
  amber:   { bg: 'rgba(245,158,11,0.15)',   text: '#fbbf24' },
  slate:   { bg: 'rgba(100,116,139,0.15)',  text: '#94a3b8' },
};
